import ResourcePage from "../../components/ResourcePage";

const PlaceholderPage = ({ title, section }) => {
  return (
    <ResourcePage title={title} breadcrumb={[section, title]}>
      <div className="card app-card">
        <div className="card-body">
          <h5 className="card-title mb-2">{title}</h5>
          <p className="text-muted mb-0">Esta área já está preparada no menu e será ligada ao respectivo fluxo operacional.</p>
        </div>
      </div>
    </ResourcePage>
  );
};

export default PlaceholderPage;
